export default "__VITE_ASSET__CxsZLAw$__"